var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectionArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124.1 124.1",
    style: {
      enableBackground: "new 0 0 124.1 124.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.6,124.1h23.1c4.7,0,9-3.8,9-8.6V81.1c0-4.7,3.5-9,8.2-9h14.7c7.2,0,11.2-8.1,6.8-13.8l-44.1-55 c-3.5-4.5-10.2-4.4-13.6,0l-42.9,55c-4.4,5.7-0.4,13.8,6.8,13.8h14.8c4.7,0,8.3,4.2,8.3,9v34.4C41.7,120.3,45.8,124.1,50.6,124.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionArrowIcon);
export default __webpack_public_path__ + "static/media/direction_arrow_icon.1543374e77862a3e055ca80d615ffe12.svg";
export { ForwardRef as ReactComponent };